// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'condition-satisfactory';

export const Component = () => (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M12.5 21a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm0-4.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'
  />
);

export const viewBox = '0 0 25 25';
